import React from 'react';
import './VibeAuraBall.css';

/**
 * Mini vibe aura from What The Fox nickname tiles.
 * Color slowly cycles Blue → Green → Red → Orange.
 */
export default function VibeAuraBall({ className = '' }) {
  return (
    <span
      className={`feed-nickname-aura${className ? ` ${className}` : ''}`}
      aria-hidden="true"
    >
      <span className="hero-aura-cloud__blob hero-aura-cloud__blob--one" />
      <span className="hero-aura-cloud__blob hero-aura-cloud__blob--two" />
      <span className="hero-aura-cloud__blob hero-aura-cloud__blob--three" />
    </span>
  );
}
